import _get from 'lodash/get'
import { fromJS } from 'immutable'
import {
  setTitlesData,
  setTitlesProcessing,
  setTitlesError,
  GET_TITLES_DATA,
} from './redux/actions'
import { getTitles } from '.'

const log = console

export function getTitlesDataHandler ({ after }) {
  return after([GET_TITLES_DATA], async ({ dispatch, state, action } = {}) => {
    const { config, auth } = state
    try {
      dispatch(setTitlesProcessing({}))
      const options = {
        auth,
        server: config.getIn(['data', 'servers', 'brooklyn']),
        value: action.payload.value,
        type: action.payload.type,
        bundle: action.payload.bundle,
      }
      const data = await getTitles(options)
      dispatch(setTitlesData({
        data: fromJS(_get(data, 'titles')),
      }))
    } catch (error) {
      log.error(error, 'Error getting titles data for autosuggest.')
      dispatch(setTitlesError({
        error,
      }))
    }
  })
}
